export default class FiltringResult<T>{
    TotalCount: number | string = 0;    // ������ �������� "1" � �����, � �� �����
    Page: number = 0;
    PageCount: number = 0;
    Entities: Array<T> = [];   
}